import React from 'react';

export const GoogleDriveSearchResultIcon = (): React.JSX.Element => {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="32" height="32" rx="8" fill="white" />
			<rect
				x="0.508324"
				y="0.508324"
				width="30.9834"
				height="30.9834"
				rx="7.49168"
				stroke="#0B1228"
				strokeOpacity="0.14"
				strokeWidth="1.01665"
			/>
			<g>
				<path
					d="M6.94608 22.7709L7.8869 24.3877C8.08239 24.728 8.36342 24.9955 8.69331 25.1899L12.0534 19.4038H5.33325C5.33325 19.7806 5.431 20.1575 5.62649 20.4978L6.94608 22.7709Z"
					fill="#0066DA"
				/>
				<path
					d="M15.9999 12.5966L12.6399 6.81049C12.31 7.00498 12.0289 7.2724 11.8334 7.61276L5.62649 18.3098C5.43459 18.6428 5.33351 19.02 5.33325 19.4038H12.0534L15.9999 12.5966Z"
					fill="#00AC47"
				/>
				<path
					d="M23.3066 25.1899C23.6365 24.9955 23.9175 24.728 24.113 24.3877L24.504 23.7191L26.3734 20.4978C26.5689 20.1575 26.6667 19.7806 26.6667 19.4038H19.946L21.3761 22.1996L23.3066 25.1899Z"
					fill="#EA4335"
				/>
				<path
					d="M16 12.5967L19.36 6.81054C19.0301 6.61604 18.6513 6.5188 18.2604 6.5188H13.7395C13.3486 6.5188 12.9698 6.6282 12.6399 6.81054L16 12.5967Z"
					fill="#00832D"
				/>
				<path
					d="M19.9463 19.4038H12.0532L8.69312 25.1899C9.02301 25.3844 9.40178 25.4817 9.79277 25.4817H22.2067C22.5977 25.4817 22.9764 25.3723 23.3063 25.1899L19.9463 19.4038Z"
					fill="#2684FC"
				/>
				<path
					d="M23.2697 12.9613L20.1662 7.61276C19.9707 7.2724 19.6897 7.00498 19.3598 6.81049L15.9998 12.5966L19.9463 19.4038H26.6542C26.6542 19.027 26.5565 18.6502 26.361 18.3098L23.2697 12.9613Z"
					fill="#FFBA00"
				/>
			</g>
		</svg>
	);
};
